<style scoped>
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.file-name {
  color: #212121;
  margin-left: 4px;
  margin-right: 4px;
  width: calc(100% - 130px);
}
.file-operate {
  display: flex;
}
/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-dialog__header {
  text-align: left;
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__title {
  font-size: 16px;
}

/deep/ .el-upload-list__item-name {
  white-space: inherit;
}

.el-upload__tip {
  line-height: 22px;
}

.el-form-item {
  margin-bottom: 8px;
}
</style>
<template>
  <el-dialog
    title="填写通过备注"
    v-loading.fullscreen.lock="fullscreenLoading"
    :visible.sync="visible"
    width="640px"
    class="importClass"
  >
    <div class="pass-box">
      <el-form label-width="120px" label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">票据信息上传：</span>
          <el-upload
            class="upload-demo fl t-left"
            action="#"
            multiple
            accept=".ofd,.pdf,.PDF,.docx,.xlsx,.doc,.xlsm,.zip,.rar,.jpg,.png,.jpeg"
            :on-remove="handleRemoveInvoice"
            :http-request="uploadInvoice"
            :file-list="invoiceAttach"
            :beforeUpload="beforeAvatarUpload"
          >
            <el-button size="mini" type="info">点击上传文件</el-button>
            <div class="file-operate" slot="file" slot-scope="{ file }">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-preview" @click="onPreview(file)">查看</div>
              <div class="file-preview" @click="handleRemoveInvoice(file)">
                删除
              </div>
              <div class="file-preview" @click="onDownload(file)">下载</div>
            </div>
            <div slot="tip" class="el-upload__tip">
              当前支持 word、pdf、excel、zip、jpg、png、ofd，请使用 Office 2010
              及以上版本，否则可能出现乱码，单个文件不得大于20M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">开票时间：</span>
          <el-date-picker
            class="fl w100f"
            v-model="formData.invoiceDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <div style="clear: both"></div>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">税率(%)：</span>
          <el-input
            v-model.trim="formData.taxRate"
            class="fl"
            placeholder="请输入"
            onkeyup="value=value.replace(/[^\d.]/g, '')"
            maxlength="5"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-input
        class="fl"
        type="textarea"
        :rows="5"
        :maxlength="200"
        placeholder="最多可输入200个字"
        v-model="formData.approveSuggest"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f mt15" @click="handleSubmit()"
          >通过</el-button
        >
      </span>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flowType: {
      type: String,
      default: "00017",
    },
  },
  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      visible: false,
      fullscreenLoading: false,
      rowData: null,
      formData: {
        guid: null,
        invoiceDate: null,
        taxRate: null,
        invoiceAttach: [],
        approveGuid: null,
        approveStaffGuid: null,
        flowType: null,
        approveSuggest: null,
      },
      invoiceAttach: [],
    };
  },
  methods: {
    onPreview(file) {
      const fileSuffix = file.name
        ? file.name.substring(file.name.lastIndexOf(".") + 1)
        : "";
      if (
        fileSuffix === "png" ||
        fileSuffix === "jpeg" ||
        fileSuffix === "jpg" ||
        fileSuffix === "pdf" ||
        fileSuffix === "zip"
      ) {
        return window.open(file.path, file.name);
      }
      if (fileSuffix == "ofd") {
        return window.open(
          "https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)
        );
      }
      window.open(
        "https://view.officeapps.live.com/op/view.aspx?src=" + file.path
      );
    },
    onDownload(file) {
      window.open(
        file.path + "?response-content-type=application/octet-stream"
      );
    },
    open(rowData) {
      this.rowData = rowData;
      this.visible = true;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        guid: null,
        invoiceDate: null,
        taxRate: null,
        invoiceAttach: [],
        approveGuid: null,
        approveStaffGuid: null,
        flowType: null,
        approveSuggest: null,
      };
      this.invoiceAttach = [];
    },
    handleSubmit() {
      if (!this.invoiceAttach.length) {
        this.$message.error("票据信息上传不能为空！");
        return;
      }
      if (!this.formData.invoiceDate) {
        this.$message.error("开票日期不能为空！");
        return;
      }
      if (!this.formData.taxRate) {
        this.$message.error("税率不能为空！");
        return;
      }

      this.formData.invoiceAttach = this.invoiceAttach?.map((item) => {
        return {
          fileName: item.name,
          path: item.path,
        };
      });

      let userinfo = JSON.parse(localStorage.userInfo);
      this.formData.guid = this.rowData.guid;
      this.formData.approveGuid =
        this.rowData.approveGuid || this.rowData.approveVO?.approveGuid;
      this.formData.flowType = this.flowType;
      this.formData.approveStaffGuid = userinfo.staffGuid;
      this.formData.taxRate = this.formData.taxRate
        ? Number(this.formData.taxRate)
        : null;
      this.fullscreenLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/upstream/payment/invoice-upload`,
          this.formData
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.visible = false;
            this.resetForm();
            this.$emit("passSuccess", "success");
            this.$message({
              message: "提交成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleRemoveInvoice(file) {
      let self = this;
      self.invoiceAttach.forEach((j, ind) => {
        if (j.path == file.path) {
          self.invoiceAttach.splice(ind, 1);
        }
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: "warning",
        });
      }
      return isLt2M;
    },
    uploadInvoice(file) {
      let self = this;
      let formData = new FormData();
      formData.append("image", file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            self.invoiceAttach.push(item);
            self.$message.success("上传成功");
          } else {
            self.$message.error("上传失败,请重新上传!");
          }
        })
        .catch(() => {
          self.$message("上传失败,请重新上传");
        });
    },
  },
};
</script>
